import React, {useEffect} from "react"
import {Table} from "antd"
import moment from "moment"
import {useBlackListContext} from "../store/useBlackListContext"
import BlackListDeleted from "./BlackListDeleted"

const BlackListTable = () => {

    const {getBlackList, blackList, isLoading} = useBlackListContext()

    const columns = [
        {
            title: 'id',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: '会员id',
            dataIndex: 'member_id',
            key: 'member_id',
        },
        {
            title: '用户',
            dataIndex: 'member_name',
            key: 'member_name',
        },
        {
            title: '昵称',
            dataIndex: 'nickname',
            key: 'nickname',
        },
        {
            title: '电话',
            dataIndex: 'account',
            key: 'account',
        },
        {
            title: '备注',
            dataIndex: 'note',
            key: 'note',
        },
        {
            title: '操作时间',
            dataIndex: 'ctime',
            key: 'ctime',
            width: 170,
            render: (text) => (text && moment(text).isValid())
                ? moment(text).format('YYYY-MM-DD HH:mm:ss')
                : '-',
        },
        {
            title: '操作',
            dataIndex: 'edit',
            key: 'edit',
            render: (text, record) => <BlackListDeleted recordId={record.id} memberName={record.member_name}/>
        },
    ]

    useEffect(() => {
        getBlackList()
    }, [])

    return (
        <div>
            <Table
                bordered
                columns={columns}
                dataSource={blackList}
                loading={isLoading}
            />
        </div>
    )
}

export default BlackListTable


// WEBPACK FOOTER //
// ./src/containers/ClubBlacklist/component/BlackListTable.js